import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditProgramService
{
  constructor(private http: HttpClient) { }

  /**
   * Get audit programs details
   *
   * @param programId Program Id
   * @param revisionId Revision Id
   */
  public getAuditProgramDetails(detailTypeUrl: string, programId: number, revisionId: number, revisionType: number): Observable<any>
  {
    return this.http.get<any>(`/audit/${detailTypeUrl}/details/${programId}/${revisionId}/${revisionType}`);
  }
}